<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container">
  <div class="row mt-3">
    <div class="col-md-12 text-center" style="font-size:1.6em; font-weight:bold">
      CLAIM FORM
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-12">
      Prior to completing this form, it is important that you review the <b>Notice of Proposed Class Action Settlement, February 11, 2027 Final Approval Hearing Thereon and Settlement Class Members' Rights</b> and the
      <b>Amended Class Action Settlement Agreement and Release</b> between Plaintiffs and GoodRx Holdings, Inc. and Criteo Corp., which are available <a [routerLink]="['/court-documents']" style="color:#006cDb">here</a>,
      for information on who is eligible for a Settlement payment.<br /><br />

      Please submit a Claim Form <b>on the Settlement Website by 11:59 p.m. Eastern Time on December 29, 2026 OR complete and mail this form to the Settlement Administrator postmarked no later than December 29, 2026.</b>
      If you cannot submit the required information below or have questions, call or email the Settlement Administrator for further instructions. Each Settlement Class Member may file <b><u>one Claim Form only</u></b> for a <i>pro rata</i> cash
      payment from the Net Settlement Fund, regardless of the number of notices that they may receive.
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12" style="font-weight:bold">
      I. CLAIMANT INFORMATION
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12">
      Please provide all of the required information below. The Settlement Administrator will use this information to communicate with you about this Claim Form. If this information changes after you submit this form, please
      notify the Settlement Administrator in writing. If you are completing and signing this Claim Form on behalf of the Claimant, you must attach documentation showing you have the authority to act on behalf of the Claimant.
    </div>
  </div>
  <br />
  <div class="container">
    <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="firstName">First Name:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="firstName" formControlName="firstName" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.firstName.errors && (f.firstName.dirty || f.firstName.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.firstName" class="invalid-feedback">
              <div *ngIf="f.firstName.hasError(validation.type) && (f.firstName.dirty || f.firstName.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="lastName">Last Name:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="lastName" formControlName="lastName" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.lastName.errors && (f.lastName.dirty || f.lastName.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.lastName" class="invalid-feedback">
              <div *ngIf="f.lastName.hasError(validation.type) && (f.lastName.dirty || f.lastName.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="street1">Street Address (no P.O. Boxes):<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="street1" formControlName="street1" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.street1.errors && (f.street1.dirty || f.street1.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.street1" class="invalid-feedback">
              <div *ngIf="f.street1.hasError(validation.type) && (f.street1.dirty || f.street1.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="city">City:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="city" formControlName="city" placeholder="" autocomplete="off"
                   trim="blur" [ngClass]="{ 'is-invalid': f.city.errors && (f.city.dirty || f.city.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.city" class="invalid-feedback">
              <div *ngIf="f.city.hasError(validation.type) && (f.city.dirty || f.city.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label class="titleBold" for="state">State:<span style="color:red" class="required"> *</span></label>
          <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': f.state.errors && (f.state.dirty || f.state.touched )}">
            <option value="">Please select a State</option>
            <option *ngFor="let allstate of allStates">
              {{allstate.Name}}
            </option>
          </select>
          <div *ngFor="let validation of validation_FormErrorMessages.state" class="invalid-feedback">
            <div *ngIf="f.state.hasError(validation.type) && (f.state.dirty || f.state.touched)">
              {{ validation.message }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="zip">Zip Code:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="zip" formControlName="zip"
                   placeholder="Zip Code: (XXXXX or XXXXX-XXXX)" autocomplete="off" trim="blur"
                   [ngClass]="{ 'is-invalid': f.zip.errors && (f.zip.dirty || f.zip.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.zip" class="invalid-feedback">
              <div *ngIf="f.zip.hasError(validation.type) && (f.zip.dirty || f.zip.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="emailAddress">Email Address:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors && (f.emailAddress.dirty || f.emailAddress.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.emailAddress" class="invalid-feedback">
              <div *ngIf="f.emailAddress.hasError(validation.type) && (f.emailAddress.dirty || f.emailAddress.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="phone1">Phone Number:<span style="color:red" class="required"> *</span></label>
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" id="phone1" formControlName="phone1" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                   [ngClass]="{ 'is-invalid': f.phone1.errors && (f.phone1.dirty || f.phone1.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.phone1" class="invalid-feedback">
              <div *ngIf="f.phone1.hasError(validation.type) && (f.phone1.dirty || f.phone1.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12" style="font-weight:bold">
          Optional: Unique ID and PIN
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-2">
          If you received a Unique ID and PIN, please enter it below to assist with the processing of your claim.  This is <b>not</b> required to file a claim.
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="uniqueId">Unique ID:</label>
            <input type="text" class="form-control" id="uniqueId" formControlName="uniqueId" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.uniqueId.errors && (f.uniqueId.dirty || f.uniqueId.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.uniqueId" class="invalid-feedback">
              <div *ngIf="f.uniqueId.hasError(validation.type) && (f.uniqueId.dirty || f.uniqueId.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="pin">PIN:</label>
            <input type="text" class="form-control" id="pin" formControlName="pin" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.pin.errors && (f.pin.dirty || f.pin.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.pin" class="invalid-feedback">
              <div *ngIf="f.pin.hasError(validation.type) && (f.pin.dirty || f.pin.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12" style="font-weight:bold">
          II. PAYMENT ELECTION<span style="color:red" class="required"> *</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div id="claim-form-placeholder"></div>
          <div *ngIf="submitted && !payoutPreferenceId" class="invalid-feedback" style="display:block">
            Please select a payment method
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12" style="font-weight:bold">
          III. ATTESTATION AND CERTIFICATION<span style="color:red" class="required"> *</span>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group form-check">
                <input type="checkbox" formControlName="acknowledgement" class="form-check-input" trim="blur" [ngClass]="{ 'is-invalid': f.acknowledgement.errors && (f.acknowledgement.dirty || f.acknowledgement.touched )}" />
                <label for="acknowledgement">
                  I attest that I resided in the United States and used any website, app, or service made available by or through GoodRx at any time prior to April 20, 2024.
                </label>
                <div *ngFor="let validation of validation_FormErrorMessages.acknowledgement" class="invalid-feedback">
                  <div *ngIf="f.acknowledgement.hasError(validation.type) && (f.acknowledgement.dirty || f.acknowledgement.touched)">
                    {{ validation.message }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div style="font-size:1.2em; font-weight:bold">
            I CERTIFY THAT ALL THE INFORMATION PROVIDED BY ME IN CONNECTION WITH THIS CLAIM FORM IS TRUE, CORRECT, AND COMPLETE.
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="signature">Electronic Signature: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.signature.errors && (f.signature.dirty || f.signature.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.signature" class="invalid-feedback">
              <div *ngIf="f.signature.hasError(validation.type) && (f.signature.dirty || f.signature.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid': f.googleRecaptchaToken.errors && (f.googleRecaptchaToken.dirty || f.googleRecaptchaToken.touched )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.googleRecaptchaToken" class="invalid-feedback">
              <div *ngIf="f.googleRecaptchaToken.hasError(validation.type) && (f.googleRecaptchaToken.dirty || f.googleRecaptchaToken.touched)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <ul class="list-inline text-center">
        <li *ngIf="!credentialAlreadyUsed"><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
        <li *ngIf="credentialAlreadyUsed"><button type="button" class="btn btn-primary" [disabled]="clicked" (click)="continueAsUnverified()">Continue as unverified claim</button></li>
      </ul>
      <div *ngIf="errorMessage" class="alert alert-danger text-center">
        {{ errorMessage }}<br />
        Please call <a href="tel:+18667789626" style="color:#006cDb">1-866-778-9626</a> or email
        <a href="mailto:info@goodrxprivacysettlement.com" style="color:#006cDb">info@goodrxprivacysettlement.com</a> for assistance.
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="text-center" style="text-decoration:underline; font-weight:bold">
            REMINDER:
          </h5>
        </div>

        <div class="col-md-12 text-center">
          <b>YOUR SETTLEMENT CLAIM FORM MUST BE SUBMITTED ONLINE BY 11:59 P.M. EASTERN TIME ON DECEMBER 29, 2026 OR POSTMARKED AND MAILED NO LATER THAN DECEMBER 29, 2026 TO:</b><br /><br />

          <div class="text-center">
            <i><b>GoodRx Data Disclosure Settlement</b></i><br />
            c/o A.B. Data, Ltd.<br />
            P.O. Box 173138<br />
            Milwaukee, WI 53217<br />
          </div>
        </div>

      </div>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>
